var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetwork2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 138.54 143.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 138.54,
    height: 122.67,
    rx: 10,
    ry: 10,
    fill: "#c92123"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7 86.24h12.08c5.84-9.34 31.83-5.93 53.1-3.69 9.36.98 17.8 1.74 23.2 1.09-8.29-.93-16.02-2.17-23.2-3.48-35.85-6.53-57.89-14.75-65.17 6.08zM111.58 31.27c-2.03-13.31-13.21-14.24-24.7-10.91-8.92 2.58-18.03 7.73-23.2 11.65 4.43-2.85 14.3-7.52 23.2-9.62 7.22-1.71 13.8-1.72 16.29 2.29 4.72 7.59-.42 51.52 18.14 61.54.86.46 1.76.86 2.72 1.17a17.99 17.99 0 01-2.72-2.17c-12.05-11.74-7.61-40.07-9.73-53.95z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.21 56.75c4.86-1.57 5.1-12.21-.33-11.25l-16.96 2.67c.31-.88.7-1.83 1.19-2.86 4.04-8.47 19.75-9 31.76-8.57 3.59.13 6.85.34 9.36.45-2.88-.48-6.06-1.05-9.36-1.56-18.21-2.83-40.4-4-40.04 19.43-4.18 1.23-20.95 5.11-24.65 6.15-2.49 7.45-5.77 19.37-7.67 26.8 3.58-7.88 7.12-16.56 9.98-23.74 11.53-2.17 35.35-5.87 46.72-7.53z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork2);
export default __webpack_public_path__ + "static/media/network2.eb5a18cbb191f060138f2d81c434f151.svg";
export { ForwardRef as ReactComponent };